import { gql } from "@apollo/client";

export const GET_DOCTOR_TO_PROCESS_ROLE = gql`
  query GET_DOCTOR_TO_PROCESS_ROLE($userToProcessId: uuid) {
    doctorToProcessRole(where: { userToProcessId: { _eq: $userToProcessId } }) {
      doctorId
      id
      processId
      roleId
      userToProcessId
      doctor {
        id
        email
        lastname
        name
      }
    }
  }
`;
